import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, resolveDirective as _resolveDirective, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "col col-12" }
const _hoisted_2 = { class: "row py-3 px-4 g-0" }
const _hoisted_3 = { class: "col-12 col-lg-6 px-4 col-md-12 g-0" }
const _hoisted_4 = { class: "col-12 py-2" }
const _hoisted_5 = { class: "row col-12" }
const _hoisted_6 = { class: "form-group col-12 col-lg-6" }
const _hoisted_7 = {
  id: "contact_first_name",
  for: "contact_first_name"
}
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" First Name")
const _hoisted_9 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_10 = { class: "form-group col-12 col-lg-6" }
const _hoisted_11 = { for: "contact_last_name" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Last Name")
const _hoisted_13 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_14 = { class: "form-group col-12 col-lg-12 pe-lg-2" }
const _hoisted_15 = { for: "contact-mobile-number" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Mobile Phone ")
const _hoisted_17 = { class: "fas fa-question-circle" }
const _hoisted_18 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_19 = { class: "form-group col-12 col-lg-12 pe-lg-2" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", { for: "contact-alternate-mobile" }, " Alternate Phone ", -1 /* HOISTED */)
const _hoisted_21 = { class: "form-group col-12 col-lg-12 pe-lg-2" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", { for: "contact_relationship" }, " Relationship", -1 /* HOISTED */)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("option", { value: 0 }, "Select Relationship", -1 /* HOISTED */)
const _hoisted_24 = ["value"]
const _hoisted_25 = { class: "form-group col-12 col-lg-12 pe-lg-2" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", { for: "auth-contact-rel-desc" }, " Other ", -1 /* HOISTED */)
const _hoisted_27 = { class: "form-group col-12 col-lg-12 pe-lg-2" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("label", { for: "contact-email" }, " Email ", -1 /* HOISTED */)
const _hoisted_29 = { class: "col-12 py-2 ms-3" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("p", null, "Representative", -1 /* HOISTED */)
const _hoisted_31 = { class: "form-check custom-checkbox" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "Legal Representative"
}, " Legal Representative ", -1 /* HOISTED */)
const _hoisted_33 = { class: "form-check custom-checkbox" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "Patient Selected Representative"
}, " Patient Selected Representative ", -1 /* HOISTED */)
const _hoisted_35 = { class: "col-12 col-lg-6 px-4 col-md-12 g-0 mt-2" }
const _hoisted_36 = { class: "w-100" }
const _hoisted_37 = { class: "form-check custom-checkbox" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "contact-address"
}, " Same as Patient Address ", -1 /* HOISTED */)
const _hoisted_39 = { class: "row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ReferralAddressForm = _resolveComponent("ReferralAddressForm")!
  const _component_FormSection = _resolveComponent("FormSection")!
  const _directive_tooltip = _resolveDirective("tooltip")!
  const _directive_number_only = _resolveDirective("number-only")!

  return (_openBlock(), _createBlock(_component_FormSection, {
    title: "Primary Emergency Contact",
    type: "his-section",
    "full-height": false,
    "application-id": Number(_ctx.application)
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("section", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("label", _hoisted_7, [
                    _hoisted_8,
                    (_ctx.isFieldRequired)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_9, "*"))
                      : _createCommentVNode("v-if", true)
                  ]),
                  _withDirectives(_createElementVNode("input", {
                    id: "contact_first_name",
                    name: "contact_first_name",
                    class: _normalizeClass(["form-control", `form-control ${
                                            _ctx.v$.referral.Contacts.PrimaryEmergencyContact.FirstName.$error ||
                                            _ctx.errors.Contacts.includes('FirstName')
                                                ? 'border border-warning'
                                                : ''
                                        }`]),
                    maxlength: "50",
                    type: "text",
                    placeholder: "Enter First Name",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.referral.Contacts.PrimaryEmergencyContact.FirstName) = $event)),
                    onBlur: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.v$.referral.Contacts.PrimaryEmergencyContact.FirstName.$touch && _ctx.v$.referral.Contacts.PrimaryEmergencyContact.FirstName.$touch(...args))),
                    onChange: _cache[2] || (_cache[2] = (e) => _ctx.handleAllInputChange('FirstName', e.target.value))
                  }, null, 34 /* CLASS, HYDRATE_EVENTS */), [
                    [_vModelText, _ctx.referral.Contacts.PrimaryEmergencyContact.FirstName]
                  ])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("label", _hoisted_11, [
                    _hoisted_12,
                    (_ctx.isFieldRequired)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_13, "*"))
                      : _createCommentVNode("v-if", true)
                  ]),
                  _withDirectives(_createElementVNode("input", {
                    name: "contact_last_name",
                    class: _normalizeClass(`form-control ${
                                            _ctx.v$.referral.Contacts.PrimaryEmergencyContact.LastName.$error ||
                                            _ctx.errors.Contacts.includes('LastName')
                                                ? 'border border-warning'
                                                : ''
                                        }`),
                    type: "text",
                    maxlength: "50",
                    placeholder: "Enter Last Name",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.referral.Contacts.PrimaryEmergencyContact.LastName) = $event)),
                    onBlur: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.v$.referral.Contacts.PrimaryEmergencyContact.LastName.$touch && _ctx.v$.referral.Contacts.PrimaryEmergencyContact.LastName.$touch(...args))),
                    onChange: _cache[5] || (_cache[5] = (e) => _ctx.handleAllInputChange('LastName', e.target.value))
                  }, null, 34 /* CLASS, HYDRATE_EVENTS */), [
                    [_vModelText, _ctx.referral.Contacts.PrimaryEmergencyContact.LastName]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("label", _hoisted_15, [
                  _hoisted_16,
                  _withDirectives(_createElementVNode("i", _hoisted_17, null, 512 /* NEED_PATCH */), [
                    [_directive_tooltip, {
                                            title: `For emergency preparedness, patient will be contacted at this number. This will also populate to the emergency preparedness report.`,
                                            placement: 'right'
                                        }]
                  ]),
                  (_ctx.isFieldRequired)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_18, "*"))
                    : _createCommentVNode("v-if", true)
                ]),
                _withDirectives(_createElementVNode("input", {
                  id: "contact-mobile-number",
                  type: "text",
                  class: _normalizeClass(`form-control phone-number-input ${
                                        _ctx.v$.referral.Contacts.PrimaryEmergencyContact.PrimaryPhone.$error ||
                                        _ctx.errors.Contacts.includes('PrimaryPhone')
                                            ? 'border border-warning'
                                            : ''
                                    }`),
                  maxlength: 10,
                  placeholder: "Enter Number",
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.referral.Contacts.PrimaryEmergencyContact.PrimaryPhone) = $event)),
                  onBlur: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.v$.referral.Contacts.PrimaryEmergencyContact.PrimaryPhone.$touch && _ctx.v$.referral.Contacts.PrimaryEmergencyContact.PrimaryPhone.$touch(...args))),
                  onChange: _cache[8] || (_cache[8] = (e) => _ctx.handleAllInputChange('PrimaryPhone', e.target.value))
                }, null, 34 /* CLASS, HYDRATE_EVENTS */), [
                  [_directive_number_only],
                  [_vModelText, _ctx.referral.Contacts.PrimaryEmergencyContact.PrimaryPhone]
                ])
              ]),
              _createElementVNode("div", _hoisted_19, [
                _hoisted_20,
                _withDirectives(_createElementVNode("input", {
                  id: "contact-alternate-mobile",
                  type: "text",
                  class: "form-control phone-number-input",
                  maxlength: 10,
                  placeholder: "Enter Number",
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.referral.Contacts.PrimaryEmergencyContact.AlternatePhone) = $event))
                }, null, 512 /* NEED_PATCH */), [
                  [_directive_number_only],
                  [_vModelText, _ctx.referral.Contacts.PrimaryEmergencyContact.AlternatePhone]
                ])
              ]),
              _createElementVNode("div", _hoisted_21, [
                _hoisted_22,
                _withDirectives(_createElementVNode("select", {
                  class: "form-select",
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.referral.Contacts.PrimaryEmergencyContact.RelationOption) = $event))
                }, [
                  _hoisted_23,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.referralOptions?.relation, (relation, index) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: index,
                      value: relation.value
                    }, _toDisplayString(relation.text), 9 /* TEXT, PROPS */, _hoisted_24))
                  }), 128 /* KEYED_FRAGMENT */))
                ], 512 /* NEED_PATCH */), [
                  [_vModelSelect, _ctx.referral.Contacts.PrimaryEmergencyContact.RelationOption]
                ])
              ]),
              _createElementVNode("div", _hoisted_25, [
                _hoisted_26,
                _withDirectives(_createElementVNode("input", {
                  name: "auth-contact-rel-desc",
                  class: "form-control",
                  type: "text",
                  placeholder: "Enter Relationship",
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.referral.Contacts.PrimaryEmergencyContact.Relationship) = $event))
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelText, _ctx.referral.Contacts.PrimaryEmergencyContact.Relationship]
                ])
              ]),
              _createElementVNode("div", _hoisted_27, [
                _hoisted_28,
                _withDirectives(_createElementVNode("input", {
                  name: "contact-email",
                  class: "form-control",
                  maxlength: "50",
                  type: "text",
                  placeholder: "Enter Email Address",
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.referral.Contacts.PrimaryEmergencyContact.EmailAddress) = $event))
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelText, _ctx.referral.Contacts.PrimaryEmergencyContact.EmailAddress]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_29, [
              _hoisted_30,
              _createElementVNode("div", _hoisted_31, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  class: "form-check-input",
                  id: "Legal Representative",
                  value: 1,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.referral.Contacts.PrimaryEmergencyContact.LegalRepresentative) = $event))
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelCheckbox, _ctx.referral.Contacts.PrimaryEmergencyContact.LegalRepresentative]
                ]),
                _hoisted_32
              ]),
              _createElementVNode("div", _hoisted_33, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  class: "form-check-input",
                  id: "Patient Selected Representative",
                  value: 2,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.referral.Contacts.PrimaryEmergencyContact.PatientSelectedRepresentative) = $event))
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelCheckbox, _ctx.referral.Contacts.PrimaryEmergencyContact.PatientSelectedRepresentative]
                ]),
                _hoisted_34
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_35, [
            _createElementVNode("div", _hoisted_36, [
              _createElementVNode("div", _hoisted_37, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  class: "form-check-input",
                  id: "contact-address",
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.referral.Contacts.SameAsPatientAddress) = $event)),
                  onChange: _cache[16] || (_cache[16] = ($event: any) => (_ctx.setSameAsPatient()))
                }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
                  [_vModelCheckbox, _ctx.referral.Contacts.SameAsPatientAddress]
                ]),
                _hoisted_38
              ])
            ]),
            _createElementVNode("div", _hoisted_39, [
              _createVNode(_component_ReferralAddressForm, {
                address: _ctx.referral.Contacts.PrimaryEmergencyContact.Address,
                addressType: "PrimaryEmergencyContact",
                zipChanged: _ctx.handleZipChange,
                "county-data": _ctx.primaryEmergency
              }, null, 8 /* PROPS */, ["address", "zipChanged", "county-data"])
            ])
          ])
        ])
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["application-id"]))
}